import * as React from "react";

// El campo se llama "X": el ícono es el logo actual, no el pájaro de Twitter.
const TwitterLineIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M17.75 3h3.06l-6.69 7.64L22 21h-6.16l-4.83-6.31L5.5 21H2.44l7.15-8.17L2 3h6.31l4.36 5.77L17.75 3Zm-1.07 16.2h1.69L7.4 4.72H5.58l11.1 14.48Z" />
  </svg>
);

export default TwitterLineIcon;
